<mat-card appearance="outlined" *appRoles="['Usuarios.Listar']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Usuarios</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar})"></app-button-new>
    </div>
  </mat-card-header>
  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
      </div>
      <div class="row">

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Usuario</mat-label>
            <input matInput type="text" formControlName="UserName" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nombre</mat-label>
            <input matInput type="text" formControlName="Nombre" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Correo</mat-label>
            <input matInput type="text" formControlName="Correo" />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <mat-checkbox formControlName="EsActivoEmpresa" aria-label="Activo">
            Activo
          </mat-checkbox>
        </div>


        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas de Alta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
              <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="EsActivo">
            Activo
          </mat-checkbox>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">

          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spUsuario" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">
        <ng-container matColumnDef="userName">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Nombre de usuario</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let empresaUsuario">
            {{ empresaUsuario.usuario?.userName | lowercase }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="nombreCompleto">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Nombre Completo</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let empresaUsuario"><span>
              {{ empresaUsuario.usuario?.nombre | titlecase }} {{ empresaUsuario.usuario?.apellido | titlecase }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="correo">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Correo</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let empresaUsuario">
            <a href="mailto:{{ empresaUsuario.usuario?.correo }}">
              <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-envelope-fill" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z" />
              </svg>
              {{ empresaUsuario.usuario?.correo}}
            </a>
          </mat-cell>
        </ng-container>
        <!-- Permiso  Column -->
        <ng-container matColumnDef="rol">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Rol</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let empresaUsuario">
            {{ empresaUsuario.rol?.descripcion }}
          </mat-cell>
        </ng-container>
        <!-- Estado  Column -->
        <ng-container matColumnDef="estado">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Activo</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let empresaUsuario">
            <app-status-badge [estado]="empresaUsuario.activo"></app-status-badge>
          </mat-cell>
        </ng-container>



        <ng-container matColumnDef="estados">
          <mat-header-cell mat-header-cell *matHeaderCellDef><strong>Estados</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let empresaUsuario">
            <mat-icon matTooltip="Esta activo" class="icon-hover"
              *ngIf="empresaUsuario.usuario?.activo">toggle_on</mat-icon>

            <mat-icon matTooltip="Correo confirmado" class="icon-hover"
              *ngIf="empresaUsuario.usuario?.correoConfirmado">mark_email_read</mat-icon>

            <mat-icon matTooltip="Teléfono confirmado" class="icon-hover"
              *ngIf="empresaUsuario.usuario?.telefonoConfirmado">phone_android</mat-icon>

            <mat-icon matTooltip="Tiene 2FA (Segundo factor de autenticidad.)" class="icon-hover"
              *ngIf="empresaUsuario.usuario?.segundoFactorHabilitado">security</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let empresaUsuario" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: empresaUsuario })"
                *appRoles="['Usuarios.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <div *ngIf="empresaUsuario.activo">

                <button mat-menu-item
                  (click)="openDialog({ accion: accionesDialog.Modificar, entidad: empresaUsuario })"
                  *appRoles="['Usuarios.Modificar']">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>


                <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: empresaUsuario })"
                  *appRoles="['Usuarios.Eliminar']">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </div>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
